// src/App.js
import React from "react";
import CarCleaningCRUD from "./CarCleaningCRUD";

export default function App() {
  return <CarCleaningCRUD />;
}
